export default __webpack_public_path__ + "static/media/template_pro__0013_14---IgorKu.fa16cb42.png";